import type { ProductMessage } from '../../../../types/ProductMessage';
import type { PriceCompareItem } from '../types/PriceCompareItem';

import { createPriceCompareItem } from './createPriceCompareItem';

export const updatePriceCompareItemProduct = (item: PriceCompareItem, product: ProductMessage): PriceCompareItem => {
    const updatedItem = createPriceCompareItem({ ...item, productId: product.id, product });
    updatedItem.initWithProduct(product);
    updatedItem.compute();
    return updatedItem;
};
